import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
// css
import "./styles/index.css";



const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(<App />);

reportWebVitals();
